<template>
  <label class="icon-box hidden-box" @click="handlerClickIcon">
    <auth-img class="icon-img" src="@/assets/img/chat/leading-examining-icon.png" alt="" />
    <div class="icon-label">导诊导医</div>
    <a-drawer
      title="导诊导医"
      width="826px"
      v-model:visible="showAlter"
      :maskClosable="false"
      :closable="false"
    >
      <div class="header-wrap">
        <div class="doctor-info">
          问诊医生：
          <span>{{ workOrderGroupInfo.doctorInfo.username }}</span>
        </div>
        <div class="open-send-records">
          <span>发送门诊病历</span>
          <a-switch v-model:checked="isSendRecord" />
        </div>
      </div>
      <a-table
        v-show="isSendRecord"
        class="table"
        :style="{ marginTop: '15.5px' }"
        :rowKey="(record, index) => index"
        :columns="data.columns"
        :data-source="data.list"
        :scroll="{ x: '100%', y: 'calc(100vh - 355px)' }"
        :transformCellText="({ text }) => (text ? text : '--')"
        :pagination="pagination"
        @change="onChangePage"
      >
        <template #isSendRecord="item">
          <a-checkbox
            class="checkbox-container"
            @change="handleChecked($event, item.record)"
            v-model:checked="item.record.checked"
          ></a-checkbox>
        </template>
        <template #offlineDiagnosis="item">
          <div class="elip--multiple" style="-webkit-line-clamp: 2">
            {{ item.text || '--' }}
          </div>
        </template>
        <template #medicationNames="col">
          <span class="elip--multiple" style="-webkit-line-clamp: 2">
            {{ (col.text && col.text.map(item => item).join('；')) || '--' }}
          </span>
        </template>
      </a-table>
      <div v-show="!isSendRecord" class="write-tip-wrap">
        <auth-img src="@/assets/img/write-icon.png" class="write-icon" alt="" />
        <div class="tips">发送门诊病历可以帮助医生就诊</div>
        <a-button class="send-record-btn" @click="isSendRecord = true">发送门诊病历</a-button>
      </div>
      <div class="footer">
        <a-button @click="closeAlter" style="margin-right: 8px">取消</a-button>
        <a-button type="primary" @click="send">确定</a-button>
      </div>
    </a-drawer>
  </label>
</template>
<script setup>
import { offLineRecordList } from '@/api/HealthRecord/index.js'
import { reactive, onMounted, ref, defineProps } from 'vue'
import { columnsMedicalRecords } from '@/constants/columns'
import { startConsult } from '@/api/workPlace/leadingExamining.js'
import { notification, message } from 'ant-design-vue'
import moment from 'moment'
const paginationConfig = {
  current: 1,
  pageSize: 20,
  showQuickJumper: true,
  showSizeChanger: true,
  total: 0
}
const props = defineProps({
  workOrderGroupInfo: {
    type: Object,
    default: () => {}
  },
  groupId: {
    type: [String, Number],
    default: ''
  }
})
const data = reactive({
  list: [],
  columns: columnsMedicalRecords,
  ucPatientId: props.workOrderGroupInfo.patientInfo.ucUserId
})
const showAlter = ref(false)
const isSendRecord = ref(false)
const patientDiseaseId = ref('')

const pagination = reactive(paginationConfig)
const listQuery = {
  pageNo: 1,
  pageSize: 20,
  ucPatientId: data.ucPatientId
}
const setTime = time => {
  return moment(time).format('YYYY-MM-DD')
}
const getList = () => {
  offLineRecordList(listQuery).then(res => {
    const paramsList = res.list.map(item => {
      const { beginTime = '', endTime = '', medicineCycle } = item.prescriptionInfo || {}
      // item.patientPermission = item.patientPermission === 1 ? '是' : '否'
      if (item.prescriptionInfo) {
        item.prescriptionInfo.beginTime = setTime(beginTime)
        item.prescriptionInfo.endTime = setTime(endTime)
        item.prescriptionInfo.medicineCycle = medicineCycle + '天'
      }
      return {
        ...item,
        ...item.prescriptionInfo
      }
    })
    data.list = paramsList
    pagination.current = res.currPage
    pagination.pageSize = res.pageSize
    pagination.total = res.totalCount
  })
}

const closeAlter = () => {
  showAlter.value = false
  patientDiseaseId.value = ''
  isSendRecord.value = false
  data.list.forEach(m => {
    m.checked = false
  })
}

const onChangePage = page => {
  listQuery.pageNo = page.current
  listQuery.pageSize = page.pageSize
  getList()
}
const handlerClickIcon = () => {
  showAlter.value = true
}

onMounted(() => {
  getList()
})
const handleChecked = (e, item) => {
  const id = item.id
  const checked = e.target.checked
  data.list.forEach(m => {
    const isSame = m.id === id
    m.checked = isSame ? checked : false
  })
  patientDiseaseId.value = checked ? id : ''
}
const send = () => {
  if (isSendRecord.value && !patientDiseaseId.value) {
    notification.error({
      message: '请选择一条门诊病历哦！'
    })
    return
  }
  const { groupId, workOrderGroupInfo } = props
  const { doctorInfo = {}, patientInfo = {} } = workOrderGroupInfo
  const params = {
    groupId,
    isSendRecord: Number(isSendRecord.value),
    ucPatientId: patientInfo.ucUserId,
    ucDoctorId: doctorInfo.ucUserId
  }
  if (isSendRecord.value) params['patientDiseaseId'] = patientDiseaseId.value
  startConsult(params).then(res => {
    console.log(res)
    closeAlter()
    message.success('已发起问诊', 3)
  })
}
</script>
<style lang="scss" scoped>
@import '../../index.scss';
.header-wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .doctor-info {
    font-family: PingFangSC-Medium;
    font-weight: 500;
    font-size: 14px;
    color: #999999;
    margin-right: 4px;

    span {
      font-family: PingFangSC-Medium;
      font-weight: 500;
      font-size: 14px;
      color: #333333;
    }
  }
  .open-send-records {
    span {
      font-family: PingFangSC-Medium;
      font-weight: bold;
      font-size: 14px;
      color: #999999;
      margin-right: 8px;
      vertical-align: middle;
    }
  }
}
.write-tip-wrap {
  text-align: center;
  padding-top: 186px;
  .write-icon {
    width: 208px;
  }
  .tips {
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 12px;
    color: #999999;
    letter-spacing: 0;
    text-align: center;
    padding: 10px 0 12px;
  }
  .send-record-btn {
    width: 120px;
    height: 36px;
    border: 1px solid #1890ff;
    border-radius: 4px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 16px;
    color: #1890ff;
  }
}
.footer {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e9e9e9;
  padding: 10px 16px;
  background: #fff;
  text-align: right;
  z-index: 1;
}
.flex-wrap {
  display: flex;
  justify-content: space-between;
}
.textarea-form-item {
  ::v-deep(.ant-form-item-label) {
    display: none;
  }
  .custom-label {
    margin-bottom: 20px;
    .symbol-icon {
      color: #f84f4f;
      font-size: 14px;
      margin-right: 4px;
    }
    .text {
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 12px;
      color: #999999;
      margin-right: 4px;
    }
    .tips {
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 12px;
      color: #ffa940;
    }
  }
}
.search-input {
  height: 36px;
  font-family: PingFangSC-Medium;
  font-weight: bold;
  font-size: 14px;
  color: #333333;
  box-sizing: border-box;
  padding: 8px 12px;
  background: rgba(250, 250, 250, 0.5);
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  &.textarea {
    box-sizing: border-box;
    padding: 8px 12px;
    resize: none;
  }
}
.textarea-wrap {
  position: relative;
  .text-tips {
    opacity: 0.6;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    font-size: 10px;
    color: #999999;
    position: absolute;
    right: 10px;
    bottom: 10px;
  }
}
</style>
